// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin: ${({ theme }) => `0 0 ${theme.spacing.spacing80} 0`};

  .badge-img {
    margin: ${({ theme }) => `0 ${theme.spacing.spacing40} 0 0`};
  }

  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    margin: ${({ theme }) => `0 0 ${theme.spacing.spacing40} 0`};
  }
`;

export const ProductTagsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Seperator = styled.div`
  height: 14px;
  width: 1px;
  margin: ${({ theme }) => `auto ${theme.spacing.spacing40}`};
  background-color: ${({ theme }) => theme.colors.textDisabled};
`;
